// extracted by mini-css-extract-plugin
export default {"adminPostsWrapper":"posts_adminPostsWrapper__HrmYD","header":"posts_header__boYJe","postsGrid":"posts_postsGrid__6qzS8","searchBar":"posts_searchBar__qmGBz"};